module.exports = "/src/views/player/documets/fib/images/fib_logo.png";